import { Component, Inject, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Template } from '../../model/template';
import { TemplateComponent } from '../../model/template-component';
import { Locale } from '../../model/locale';
import { TemplatesService } from '../../services/templates.service';
import { TemplateDeliveryPathsService } from '../../services/template-delivery-paths.service';
import { TemplateDeliveryPath } from '../../model/template-delivery-path';
import { ComponentType } from '../../model/component-type.enum';
import { TemplateProductLine } from '../../model/template-product-line';
import { TemplateProductLinesService } from '../../services/template-product-lines.service';
import { OperatorProgramsService } from '../../services/operator-programs.service';
import { Program } from '../../model/program';
import { ProductLine } from '../../model/product-line.enum';
import { DeliveryPath } from '../../model/delivery-path.enum';
import { LocalesService } from '../../services/locales.service';
import { TemplateDefinition } from '../../model/template-definition';
import { TemplateComponentVariable } from '../../model/template-component-variable';
import { TemplateComponentVariablesService } from '../../services/template-component-variables.service';
import { TemplateComponentContent } from '../../model/template-component-content';
import Mustache, { OpeningAndClosingTags } from 'mustache';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { DOCUMENT } from '@angular/common';
import { ContentPlayerComponent } from './content-player/content-player.component';
import { factory } from '../../shared/app-logging';
import * as HttpStatus from 'http-status-codes';
import { HighlightTag } from '@/app/text-input-highlight';
import { InfoPushService } from '../../services/info-push.service';
import { ErrorDataService } from '../../services/error-data.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { MapperService } from '../../services/mapper.service';
import { TtsLocaleMap } from '../../model/ttsLocaleMap';
import { TtsConfigService } from '../../services/tts-config.service';
import { AppConfig } from '../../shared/app-config';
import { TtsApplicationDefaults } from '../../model/ttsApplicationDefaults';
import { PollyService } from '../../services/polly.service';
import { PollyVoice } from '../../model/polly-voice';
import { ProgramProductsService } from '../../services/program-products.service';
import { Product } from '../../model/product';
import { OperatorsService } from '../../services/operators.service';
import { Operator } from '../../model/operator';
import { checkVoiceMail } from '../common/common';
import { UserService } from '@/app/services/user.service';
import { User } from '@/app/model/user';
import { Editor, schema, toDoc, toHTML, Toolbar } from 'ngx-editor';
import { FormControl, FormGroup } from '@angular/forms';
import templateDefinitionEditorSchema from '@/app/shared/prosemirror/schema';
import { softBreakPlugin } from '@/app/shared/prosemirror/soft-break.plugin';
import { environment } from '@/environments/environment';

interface IGetContentTextOptions {
  escapeSSMLTags?: boolean,
}

const logger = factory.getLogger('TemplateDefinitionComponent');
@Component({
  selector: 'app-template-definition',
  templateUrl: './template-definition.component.html',
  styleUrls: ['./template-definition.component.scss'],
})
export class TemplateDefinitionComponent implements OnInit, OnDestroy {
  productLineEnum = ProductLine;
  deliveryPathEnum = DeliveryPath;
  componentTypeEnum = ComponentType;
  getOperatorProgramProductDisplayLabel = TemplatesService.getOperatorProgramProductDisplayLabel;

  locales: Locale[];
  localeSel: Locale;

  templates: Template[];
  templateSel: Template;

  products: Product[];
  productSel: Product;

  templateDeliveryPaths: TemplateDeliveryPath[];
  templateDeliveryPathSel: TemplateDeliveryPath;

  templateProductLines: TemplateProductLine[];
  templateProductLineSel: TemplateProductLine;

  templateComponentVariables: TemplateComponentVariable[];
  templateComponentVariablesFull: TemplateComponentVariable[];

  templateWithContent: Template = new Template(null);
  loadingTemplateContents = true;
  templateDefinitionSel: TemplateDefinition;

  failedContentsLoadMessage = `There are no contents for the current selection.`;

  areQuotesChanged: boolean = false;

  templatePreviewText = { regularText: '', pilcrowedText: '', bodyCharCount: 0, subjectCharCount: 0 };

  isShowingPilcrowsInPreview: boolean;

  navToTemplateDefinitionSel: TemplateDefinition;

  selectedTemplateComponent: TemplateComponent = null;

  sharedTemplatesForSelectedTemplateComponent: Array<Template> = [];

  invalidSsmlTags: HighlightTag[] = [];

  isRequestingSendPreview: boolean;
  ttsAppDefaults: TtsApplicationDefaults;
  isLoadingLocaleVoiceInfo: boolean;

  editor: Editor;
  editorToolbar: Toolbar = [['bold', 'italic', 'underline', 'link']];


  editorForm = new FormGroup({
    customizingContent: new FormControl(''),
  });

  saveBreakTag = true;

  userDetails: User = {
    username: '', user_id: '',
    user_type: '',
    user_class: '',
    profile: undefined,
    preferences: undefined,
    resources: [],
    title: '',
    user_status: 'ACTIVE',
    brand: '',
    userDetails: {
      username: '',
      user_id: '',
      user_type: '',
      user_class: '',
      profile: undefined,
      preferences: undefined,
      resources: [],
      title: '',
      brand: '',
      user_status: 'ACTIVE'
    },
    userId: ''
  };

  customizingContentEditorText: string;
  customizingContentEditorTextOriginal: string;

  @ViewChild('discardCustomizingContentModal', {static: true})
  discardCustomizingContentModal: ModalDirective;


  @ViewChild('revertToDefaultContentModal', {static: true})
  revertToDefaultContentModal: ModalDirective;

  @ViewChildren(ContentPlayerComponent)
  contentPlyrs: QueryList<ContentPlayerComponent>;

  private localeMappingList: Array<TtsLocaleMap>;

  private pollyVoices: Array<PollyVoice>;

  private templateComponents: Array<TemplateComponent>;

  private sharedComponentsTemplatesList: { [componentName: string]: Array<Template> } = {};

  private warnSubjectToastrId: number;

  private subscriptions$: Subscription[] = [];
  private loadTemplateDataSubscriber: Subscription;

  constructor(
    private templatesService: TemplatesService,
    private templateDeliveryPathsService: TemplateDeliveryPathsService,
    private templateProductLinesService: TemplateProductLinesService,
    private operatorsService: OperatorsService,
    private operatorProgramsService: OperatorProgramsService,
    private programProductsService: ProgramProductsService,
    private localesService: LocalesService,
    private templateComponentVariablesService: TemplateComponentVariablesService,
    private infoPushService: InfoPushService,
    private toastr: ToastrService,
    private pollyService: PollyService,
    private mapperService: MapperService,
    private ttsConfigService: TtsConfigService,
    private userService: UserService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnDestroy(): void {
    this.subscriptions$.forEach((subscriptions) => subscriptions.unsubscribe());
    this.editor.destroy();
  }

  ngOnInit() {
    logger.debug('Init');
    logger.debug('Environment values: ' + JSON.stringify(environment));

    // Init rich text editor
    this.editor = new Editor({
        inputRules: false,
        schema: templateDefinitionEditorSchema,
        plugins: [softBreakPlugin],
    });
    // Imitating binding
    this.editorForm.get('customizingContent')?.valueChanges.subscribe(value => {
      if (this.templateDefinitionSel?.templateComponent?.componentType !== ComponentType.SUBJECT) {
        this.customizingContentEditorText = value;
      }
    });

    // Load Product Lines
    this.templateProductLinesService.findTemplateProductLines().subscribe(productLines => {
      logger.debug(`${productLines.length} productLines loaded`);
      this.templateProductLines = productLines;

      // Select default Product Line
      if (this.templateProductLines) {
        this.templateProductLineSel = this.templateProductLines.find(tpl => tpl.code === ProductLine.DEMAND_RESPONSE);

        this.templateComponentVariablesService.findTemplateComponentVariables().subscribe(variables => {
          logger.debug(`${variables.length} variables loaded`);
          this.templateComponentVariablesFull = variables.map( value => {
            if (value.sampleContent.match(/<[^>]*>/ig) ) {
              value.sampleContentHtml = 'generated html';
            } else if (value.sampleContent.match(/(?:\r\n|\r|\n)/g) ) {
              value.sampleContent = value.sampleContent.replace(/(?:\r\n|\r|\n)/g, '<br/>');
            }

            return value;
          } );

          this.filterVariablesByProductLineSel();
        });
      }
    });

    // Load Delivery Path
    this.templateDeliveryPathsService.findTemplateDeliveryPaths().subscribe(deliveryPaths => {
      logger.debug(`${deliveryPaths.length} deliveryPaths loaded`);
      this.templateDeliveryPaths = deliveryPaths;

      // Select default Delivery Path
      if (this.templateDeliveryPaths) {
        this.templateDeliveryPathSel = this.templateDeliveryPaths.find(tdp => tdp.code === DeliveryPath.EMAIL);

        this.loadTemplateData();
      }
    });

    // Load Locales
    this.localesService.findLocales().subscribe(locales => {
      logger.debug(`${locales.length} locales loaded`);
      this.locales = locales;

      // Select default Locale
      if (this.locales) {
        this.localeSel = this.locales.find(l => l.localeName === 'en_US');

        this.loadTemplateData();
      }
    });

    // Load Operators
    this.operatorsService.findOperators().subscribe(operators => {
      logger.debug(`${operators.length} operators loaded`);

      if (operators) {
        // Load Programs
        this.operatorProgramsService.findProgramsWithOperator(operators).subscribe(programs => {
          logger.debug(`${programs.length} programs loaded`);

          if (programs) {
            // Load Products
            this.programProductsService.findProductsWithProgram(programs).subscribe(products => {
              logger.debug(`${products.length} products loaded`);

              const defaultOperator = new Operator(null, 'DEFAULT');
              const defaultProgram = new Program(null, defaultOperator, 'DEFAULT', 'DEFAULT', 'DEFAULT');
              const defaultProduct = new Product(null, defaultProgram, 'DEFAULT');

              // Insert default Operator-Program-Product at the beginning
              this.products = [defaultProduct].concat(this.programProductsService.sortProducts(products));

              // Select default Product
              if (this.products) {
                this.productSel = this.products[0];

                this.loadTemplateData();
              }
            });
          }
        });
      }
    });

    // Load templates
    this.templatesService.findTemplates().subscribe(templates => {
      logger.debug(`${templates.length} templates loaded`);
      this.templates = templates;

      if (this.templates) {
        this.templateSel = this.templates.find(t => t.name === 'RT_CURTAIL');

        this.loadTemplateData();
      }
    });

    // Load TTS mapping
    this.mapperService.getTtsLocaleMappingList().subscribe(localeMappingList => {
      logger.debug(`${localeMappingList.length} mappings loaded`);
      this.localeMappingList = localeMappingList;
    });

    // Load available AWS Polly voices list
    this.pollyService.getAvailableVoices().subscribe(pollyVoices => {
      logger.debug(`${pollyVoices.length} Polly Voices loaded`);
      this.pollyVoices = pollyVoices;
    });

    // Load components
    this.templatesService.getTemplateComponents().subscribe(components => {
      logger.debug(`${components.length} Components loaded`);
      this.templateComponents = components;
    });
  }

  getUserDetail(){
    this.subscriptions$.push(
      this.userService.getUserDetailData().subscribe(
        (value: User) => {
          if (value?.userDetails?.user_id && value?.userDetails?.username) {
            this.userDetails.userDetails.user_id = value.userDetails.user_id;
            this.userDetails.userDetails.username = value.userDetails.username;
          }
        }
      )
    );
  }

  filterVariablesByProductLineSel() {
    if (this.templateComponentVariablesFull) {
      this.templateComponentVariables = this.templateComponentVariablesFull.filter(variable =>
        variable.productLine == null || variable.productLine === this.templateProductLineSel.code
      );

      logger.debug(`${this.templateComponentVariables.length} variables for product line ${this.templateProductLineSel.code}`);
    }
  }

  selectDefaultTemplateByProductLineSel() {
    if (this.templates && this.templates.length > 0 && this.templateProductLineSel) {
      switch (this.templateProductLineSel) {
        case this.templateProductLines.find(tpl => tpl.code === ProductLine.DEMAND_RESPONSE):
          this.templateSel = this.templates.find(t => t.name === 'RT_CURTAIL');
          break;
        case this.templateProductLines.find(tpl => tpl.code === ProductLine.DEMAND_RESPONSE_NON_EVENT):
          this.templateSel = this.templates.find(t => t.name === 'NO_DISPATCH');
          break;
        case this.templateProductLines.find(tpl => tpl.code === ProductLine.ENERGY_MANAGEMENT_SYSTEMS):
          this.templateSel = this.templates.find(t => t.name === 'ENERGY_ALERT');
          break;
      }

      // Default (if the given default template name was not found)
      if (!this.templateSel) {
        this.templateSel = this.templates[0];
      }
    }
  }

  resetProgramSel() {
    if (this.products) {
      this.productSel = this.products[0];
    }
  }

  loadTemplateData() {
    this.getUserDetail();

    // Remove highlights
    this.resetInvalidSsmlTags();
    if (this.templateSel && this.templateDeliveryPathSel && this.localeSel && this.productSel) {
      if (this.loadTemplateDataSubscriber && !this.loadTemplateDataSubscriber.closed) {
        this.loadTemplateDataSubscriber.unsubscribe();
      }

      this.loadingTemplateContents = true;
      this.loadTemplateDataSubscriber = this.templatesService.findTemplateComponentContents(
        this.templateSel.name,
        this.templateDeliveryPathSel.code,
        this.localeSel.localeName,
        this.productSel.id
      ).subscribe(templateWithContent => {
        logger.debug(`${templateWithContent.name} template was loaded`);
        templateWithContent.definitions.sort((a, b) => a.displaySequence - b.displaySequence);
        this.templateWithContent = templateWithContent;

        this.templateDefinitionSel = null;
        this.customizingContentEditorTextOriginal = null;

        this.navToTemplateDefinitionSel = null;

        this.loadingTemplateContents = false;

        if (this.templateDeliveryPathSel.code === DeliveryPath.VOICE) {
          this.isLoadingLocaleVoiceInfo = true;
          this.contentPlyrs.find(cPy => cPy.elContentId === 'previewContent').reset();
          if (this.templateWithContent.definitions.length > 0 && (!this.ttsAppDefaults ||
            this.ttsAppDefaults.defVoice.xcoreLocale !== this.localeSel.localeName)) {
            // Show TTS & voice details
            const localeMap = this.localeMappingList.find(localeMapping => localeMapping.xcoreLocale === this.localeSel.localeName);
            const xcoreLocaleDescription = `'${this.localeSel.displayLabels.en_US}' (${this.localeSel.localeName})`;
            if (localeMap) {
              this.ttsConfigService.getTtsApplicationDefaults(this.localeSel.localeName, AppConfig.ttsSourceApp).subscribe(ttsAppDefs => {
                this.isLoadingLocaleVoiceInfo = false;
                this.ttsAppDefaults = ttsAppDefs;
                const pollyVoice = this.pollyVoices.find(voice => voice.id === this.ttsAppDefaults.defVoice.pollyVoiceId);
                this.ttsAppDefaults.defVoice.voice = pollyVoice;
                const differentLocale = (this.localeSel.localeName).replace('_', '-') !== pollyVoice.languageCode;
                const message = `The voice content for ${xcoreLocaleDescription} will be converted ` +
                  `to speech using a ${pollyVoice.gender.toLowerCase()} voice called '${pollyVoice.name}'` +
                  (differentLocale ? ` in the following locale: '${pollyVoice.languageName}' (${pollyVoice.languageCode}).` : '.');
                this.toastr.info(message);
              });
            } else {
              this.ttsAppDefaults = null;
              this.isLoadingLocaleVoiceInfo = false;
              throw new Error(`The selected locale: ${xcoreLocaleDescription}` +
                ` can't be converted into voice speech because there is not any compatible language in AWS Polly.`);
            }
          }
        }
      }, error => {
        this.templateWithContent = new Template(null);
        this.loadingTemplateContents = false;
        if (error.status && error.status === HttpStatus.NOT_FOUND) {
          this.failedContentsLoadMessage = `There are no contents for the current selection.`;
        } else {
          this.failedContentsLoadMessage = `An error occurred. Please, try again later.`;
          throw ErrorDataService.overLoadError(error, 'While loading template contents. ');
        }
      });
    } else {
      logger.warn(`Cannot load templates yet, some params are missing`);
    }
  }

  decodeHtml(html: string): string {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }

  fixTagsInBrackets(text: string) {
    text = this.decodeHtml(text);

    const open = '{{{';
    const close = '}}}';
    let res = text;
    let pos = res.indexOf(open, 0);

    while(pos > -1) {
      let p1 = pos + 3;
      if(text[p1] === '<') {
        let moveToPosOpen = res.indexOf('>', p1);
        let moveToPosClose = res.indexOf('<', moveToPosOpen);
        let skipTo = res.indexOf(close, moveToPosClose);
        res =
          res.substring(0, pos) +                            // the string up to {{{
          res.substring(p1, moveToPosOpen + 1) +             // the opening tag, for example <b>
          open +                                             // {{{
          res.substring(moveToPosOpen + 1, moveToPosClose) + // the string between the tags
          close +                                            // }}}
          res.substring(moveToPosClose, skipTo) +            // the closing tag, for example </b>
          res.substring(skipTo + 3);                         // the rest of the string
        pos = skipTo;
      }
      pos = res.indexOf(open, pos + 1);
    }

    return res;
  }

  addTrailingBreakTag(text: string) {
    if (text.match(/<br\/?><\/div>$/)) {
      text = text.replace(/(<br\/?>)(<\/div>)$/, '$1$1$2');
    }
    return text;
  }

  checkSubjectLen() {
    if (
      this.templateDefinitionSel.templateComponent.componentType ===
      ComponentType.SUBJECT
    ) {
      const len = this.customizingContentEditorText.length;
      this.toastr.remove(this.warnSubjectToastrId);
      if (len > 200) {
        const msg = "Subject is over the character limit, please reduce it or text may be truncated after replacing variables";
        return this.warnSubjectToastrId = this.toastr.warning(msg, undefined, {
          positionClass: "toast-top-full-width",
          disableTimeOut: true,
          progressBar: false,
        }).toastId;
      }
    }
  }

  checkNumberCharacters() {
    if (
      this.templateDefinitionSel.templateComponent.deliveryPath.code === "VOICE"
    ) {
      const voiceMail = checkVoiceMail(
        this.saveBreakTag,
        this.toastr,
        this.templateDefinitionSel,
        this.customizingContentEditorText
      );

      if (voiceMail.every((breakTag: any) => breakTag.checkBreakTag)) {
        voiceMail.forEach((breakTag: any) => {
          this.customizingContentEditorText =
            this.customizingContentEditorText.replaceAll(
              breakTag.text,
              breakTag.text.replace(/'/g, '"')
            );
            if(this.customizingContentEditorText.indexOf('"') > 0){
              this.areQuotesChanged = true;
            }
        });
      }
        this.saveCustomizedContent();
    } else {
      this.saveCustomizedContent();
    }
  }

  saveCustomizedContent() {
    if (this.templateDefinitionSel) {
      const dateChanges = new Intl.DateTimeFormat(Intl.DateTimeFormat().resolvedOptions().locale, {
        dateStyle: 'full',
        timeStyle: 'long',
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      }).format(new Date());

      const tcc: TemplateComponentContent = this.getContentSelected();

      const isNewContent = !(tcc.locale === this.localeSel.localeName && tcc.productId === this.productSel.id);
      this.customizingContentEditorText = this.addTrailingBreakTag(this.fixTagsInBrackets(this.customizingContentEditorText));
      this.templatesService.saveTemplateComponentContent(
        new TemplateComponentContent(
          isNewContent ? null : tcc.id,
          tcc.templateComponent,
          this.customizingContentEditorText.replace(/\r/ig, ''),
          this.localeSel.localeName,
          this.productSel.id,
          tcc.sampleContent,
          !isNewContent && tcc.isDefaultInd,
          dateChanges,
          this.userDetails.userDetails.user_id,
          this.userDetails.userDetails.username,
          this.templateSel.name,
          tcc.templateComponent.id,
          tcc.templateComponent.componentType,
          this.areQuotesChanged,
        )
      ).subscribe(
        tccReturned => {
          const td = this.templateWithContent.definitions.find(
            tdFilter => tdFilter.templateComponent.id === tccReturned.templateComponent.id
          );
          const tccOld = td.templateComponent.contents.find(tccFilter => tccFilter.id === tccReturned.id);

          if (tccOld) {
            tccOld.content = tccReturned.content;
          } else {
            td.templateComponent.contents.push(tccReturned);
          }

          this.customizingContentEditorTextOriginal = this.customizingContentEditorText;
          this.editorForm.setValue({
            customizingContent: this.customizingContentEditorTextOriginal,
          });
          this.toastr.success(`The "${td.deliveryPath.code}" content for "${td.templateComponent.displayLabel}" ` +
            `was successfully saved for "${this.getLocaleName(tccReturned.locale)} (${tccReturned.locale})" locale and ` +
            `"${this.getOperatorProgramProductDisplayLabelById(tccReturned.productId)}" product.`,
            'Success');
          if (this.templateDeliveryPathSel.code === DeliveryPath.VOICE) {
            this.resetPlyr(this.getCompContentId(this.templateDefinitionSel));
            this.resetPlyr('previewContent');
          }
          this.areQuotesChanged = false;
        },
        error => {
          throw ErrorDataService.overLoadError(error, 'While saving customized content. ');
        }
      );
    }
  }

  discardCustomizedContent() {
    this.customizingContentEditorText = this.customizingContentEditorTextOriginal;
    this.editorForm.setValue({
      customizingContent: this.customizingContentEditorTextOriginal,
    });
    this.toastr.info('The edited content was discarded.', 'Discard confirmation');
    this.resetInvalidSsmlTags();
  }

  cancelNavToOtherCustomizedContent() {
    this.navToTemplateDefinitionSel = null;
  }

  showConfirmRevertToDefaultContent(templateDefinition: TemplateDefinition) {
    this.templateDefinitionSel = templateDefinition;

    this.revertToDefaultContentModal.show();
  }

  revertToDefaultContent() {
    if (this.templateDefinitionSel) {
      const tcc = this.getContent(this.templateDefinitionSel);

      this.templatesService.removeTemplateComponentContent(tcc.id).subscribe(
        tccReturned => {
          const td = this.templateWithContent.definitions.find(
            tdFilter => tdFilter.templateComponent.id === tccReturned.templateComponent.id
          );
          const tccOldIndex = td.templateComponent.contents.findIndex(tccFilter => tccFilter.id === tccReturned.id);

          td.templateComponent.contents.splice(tccOldIndex, 1);
          this.toastr.success(`The "${td.deliveryPath.code}" content for "${td.templateComponent.displayLabel}" ` +
            `was successfully reverted from "${this.getLocaleName(tccReturned.locale)} (${tccReturned.locale})" locale and ` +
            `"${this.getOperatorProgramProductDisplayLabelById(tccReturned.productId)}" product to "${this.getLocaleName(this.getContent(td).locale)} ` +
            `(${this.getContent(td).locale})" locale and "${this.getOperatorProgramProductDisplayLabelById(this.getContent(td).productId)}" product.`,
            'Success');

          this.loadTemplateData();
        },
        error => {
          throw ErrorDataService.overLoadError(error, 'While reverting customized content. ');
        }
      );

      this.templateDefinitionSel = null;
    }
  }

  cancelRevertToDefaultContent() {
    this.templateDefinitionSel = null;
  }

  getContent(td: TemplateDefinition): TemplateComponentContent {
    let content = null;

    if (td) {
      for (const templateComponentContent of td.templateComponent.contents) {
        if (templateComponentContent.locale === this.localeSel.localeName &&
          templateComponentContent.productId === this.productSel.id) {
          content = templateComponentContent;

          break;
        }
      }

      if (content === null) {
        for (const templateComponentContent of td.templateComponent.contents) {
          if (templateComponentContent.locale === this.localeSel.localeName &&
            !templateComponentContent.productId) {
            content = templateComponentContent;

            break;
          }
        }
      }

      if (content === null) {
        for (const templateComponentContent of td.templateComponent.contents) {
          if (templateComponentContent.isDefaultInd && templateComponentContent.productId === null) {
            content = templateComponentContent;

            break;
          }
        }
      }
    }

    return content;
  }

  getContentSelected(): TemplateComponentContent {
    return this.getContent(this.templateDefinitionSel);
  }

  escapeHTMLChars(text: string) {
    let res = '';
    const escapeChars = {
      '&': '&amp;', '"': '&quot;', "'": '&apos;', '<': '&lt;', '>': '&gt;',
    };

    for (let ch of text) {
      const shouldReplace = Object.keys(escapeChars).includes(ch);
      res += shouldReplace ? escapeChars[ch] : ch;
    }

    return res;
  }

  getContentText(tc: TemplateComponent, options: IGetContentTextOptions = {}) {
    let {
      escapeSSMLTags
    } = options;

    escapeSSMLTags = escapeSSMLTags !== undefined ? escapeSSMLTags : false;

    let content: string = null;

    for (const tcc of tc.contents) {
      if (tcc.locale === this.localeSel.localeName
          && tcc.productId === this.productSel.id
      ) {
        content = tcc.content;
        break;
      }
    }

    if (content === null) {
      for (const tcc of tc.contents) {
        if (
          tcc.locale === this.localeSel.localeName
          && !tcc.productId
        ) {
          content = tcc.content;
          break;
        }
      }
    }

    if (content === null) {
      for (const tcc of tc.contents) {
        if (
          tcc.isDefaultInd
          && tcc.productId === null
        ) {
          content = tcc.content;
          break;
        }
      }
    }

    if (content && escapeSSMLTags) {
      content = this.escapeHTMLChars(content);
    }

    return content;
  }

  getContentTextRendered(templateComponent: TemplateComponent): string {
    return this.renderContent(this.getContentText(templateComponent));
  }

  isDefaultContentSelected(): boolean {
    let isDefault = false;

    if (this.localeSel && this.productSel) {
      isDefault = this.localeSel.localeName === 'en_US' && this.productSel.id === null;
    }

    return isDefault;
  }

  getSharedComponentTemplatesCount(templateComponent: TemplateComponent): number {
    return this.getSharedComponentTemplates(templateComponent).length;
  }

  getSharedComponentTemplates(templateComponent: TemplateComponent, onlyDisplayLabels: boolean = true): Array<Template> {
    if (!this.sharedComponentsTemplatesList.hasOwnProperty(templateComponent.name)) {
      const relatedTemplates = this.getTemplatesRelatedTo(templateComponent);
      // this.sharedComponentsTemplatesList[templateComponent.name] = relatedTemplates.map((t) => t.displayLabel);
      this.sharedComponentsTemplatesList[templateComponent.name] = relatedTemplates;
    }
    return this.sharedComponentsTemplatesList[templateComponent.name];
  }

  getTemplatesRelatedToCount(templateComponent: TemplateComponent): number {
    return this.getTemplatesRelatedTo(templateComponent).length;
  }

  getTemplatesRelatedTo(templateComponent: TemplateComponent): Array<Template> {
    const templatesRelated = this.templateComponents ?
      this.templateComponents.find(comp => templateComponent.id === comp.id) :
      {templates: []};
    return templatesRelated && templatesRelated.templates ? templatesRelated.templates : [];
  }

  onSharedTemplatesSelected(templateComponent: TemplateComponent) {
    this.selectedTemplateComponent = templateComponent;
    this.sharedTemplatesForSelectedTemplateComponent = this.getSharedComponentTemplates(this.selectedTemplateComponent);
  }

  onCloseSharedTemplatesModal() {
    this.selectedTemplateComponent = undefined;
    this.sharedTemplatesForSelectedTemplateComponent = [];
  }

  isCustomizedContent(templateComponent: TemplateComponent): boolean {
    let localized = false;

    for (const templateComponentContent of templateComponent.contents) {
      if (templateComponentContent.locale === this.localeSel.localeName &&
        templateComponentContent.productId === this.productSel.id) {
        localized = !templateComponentContent.isDefaultInd;

        break;
      }
    }

    return localized;
  }

  isCustomizableContent() {
    return true;
  }

  getFormValue(path: 'customizingContent'): string {
    return String(this.editorForm.get(path).getRawValue());
  }

  customizingContentEditorExpanded(templateDefinition: TemplateDefinition) {
    if (templateDefinition) {
      if (!this.isCustomizingContentEditorTextChanged()) {
        this.navToTemplateDefinitionSel = null;

        if (this.templateDefinitionSel !== templateDefinition) {
          this.templateDefinitionSel = templateDefinition;


          const plainContentText = this.getContentText(this.templateDefinitionSel.templateComponent);

          if (
            this.templateDefinitionSel.templateComponent.componentType === ComponentType.BODY
            && this.templateDefinitionSel.deliveryPath.code === DeliveryPath.EMAIL
          ) {
            const preParsedText = this.parseContentText(this.preParse(plainContentText));
            this.customizingContentEditorText = preParsedText;
            this.customizingContentEditorTextOriginal = preParsedText;

            this.editorForm.setValue({
              customizingContent: this.customizingContentEditorText,
            });
          } else {
            this.customizingContentEditorText = plainContentText;
            this.customizingContentEditorTextOriginal = plainContentText;
          }
        } else {
          this.templateDefinitionSel = null;

          this.customizingContentEditorText = null;
          this.editorForm.setValue({
              customizingContent: '',
          });
          this.customizingContentEditorTextOriginal = null;
        }
      } else {
        this.discardCustomizingContentModal.show();
        this.navToTemplateDefinitionSel = templateDefinition;
      }
    }
  }

  isCustomizingContentEditorTextChanged() {
    return this.customizingContentEditorText && this.customizingContentEditorTextOriginal
        ? this.customizingContentEditorText !== this.customizingContentEditorTextOriginal
        : false;
  }

  isTextEmpty() {
    return !this.stripHtmlTags(this.customizingContentEditorText) || !this.stripHtmlTags(this.customizingContentEditorText.trim());
  }

  dropVariable(event: DragEvent) {
    if (this.isSelectionAContentEditor()) {
      // First way. Experimental
      if (!this.document.execCommand('insertText', false, event.dataTransfer.getData('variable'))) {
        // Second way. Compatible
        const nodeText = this.document.createTextNode(event.dataTransfer.getData('variable'));

        this.document.getSelection().getRangeAt(0).deleteContents();
        this.document.getSelection().getRangeAt(0).insertNode(nodeText);
        this.document.getSelection().getRangeAt(0).collapse(false);
      }

      this.checkSubjectLen();
    }
  }

  stripHtmlTags(html?: string) {
    return html?.replace(/<.*?>/g, '');
  }

  allowDropVariable(event: DragEvent) {
    event.preventDefault();
  }

  dragVariable(event: DragEvent, idContentEditor: string) {
    const eventTarget = event.target as HTMLElement;

    event.dataTransfer.setData('variable', eventTarget.innerText);
    event.dataTransfer.setData('idContentEditor', idContentEditor);
  }

  doubleClickVariable(event: MouseEvent, idContentEditor: string) {
    if (this.isSelectionAContentEditor()) {
      const eventTarget = event.target as HTMLElement;

      // First way. Experimental
      if (!this.document.execCommand('insertText', false, eventTarget.innerText)) {
        // Second way. Compatible
        const nodeText = this.document.createTextNode(eventTarget.innerText);

        this.document.getSelection().getRangeAt(0).deleteContents();
        this.document.getSelection().getRangeAt(0).insertNode(nodeText);
        this.document.getSelection().getRangeAt(0).collapse(false);
      }
    }
  }

  getPreviewTemplateText() {
    if (this.templateWithContent) {
      this.templatePreviewText.regularText = '';
      this.templatePreviewText.pilcrowedText = '';

      const templateDefinitionsBody = this.templateWithContent.definitions.filter(
        def => def.templateComponent.componentType === ComponentType.BODY);

      for (const templateDefinition of templateDefinitionsBody) {
        this.templatePreviewText.regularText += this.getContentTextRendered(templateDefinition.templateComponent);
        this.templatePreviewText.pilcrowedText = this.templatePreviewText.regularText.replace(/(<br\s*[\/]?>)/ig, '¶$1');
      }

      this.templatePreviewText.bodyCharCount = this.getTemplateContentTextRendered(
        this.templateDeliveryPathSel.code === DeliveryPath.SMS,
        ComponentType.BODY
      ).length;

      this.templatePreviewText.subjectCharCount = this.getTemplateContentTextRendered(
        this.templateDeliveryPathSel.code === DeliveryPath.SMS,
        ComponentType.SUBJECT
      ).length;
    }
  }

  getAllTemplateContentTextInPlainFormat(): string {
    let templateContentText = '';

    if (this.templateWithContent) {
      for (const templateDefinition of this.templateWithContent.definitions) {
        templateContentText += this.getContentText(templateDefinition.templateComponent);
      }
    }

    return templateContentText;
  }

  getTemplateContentText(componentType = ComponentType.BODY): string {
    let templateContentText = '';

    if (this.templateWithContent) {
      const templateDefinitionsBody = this.templateWithContent.definitions.filter(
        def => def.templateComponent.componentType === componentType);

      for (const templateDefinition of templateDefinitionsBody) {
        templateContentText += this.getContentText(templateDefinition.templateComponent);
      }
    }

    return templateContentText;
  }

  getTemplateContentTextRendered(plainFormat = true, componentType = ComponentType.BODY): string {
    return this.renderContent(this.getTemplateContentText(componentType));
  }

  switchTemplatePreviewShowPilcrow() {
    this.isShowingPilcrowsInPreview = !this.isShowingPilcrowsInPreview;
  }

  resetTemplatePreviewShowPilcrow() {
    this.isShowingPilcrowsInPreview = false;
  }

  /* To be called from ContentPlyr component on load captured event*/
  compContentPlyrLoadTts(e: CustomEvent) {
    this.contentPlyrs.find(cPy => cPy.elContentId === e.detail['contentId']).loadTts(
      this.getElementContentById(e.detail['contentId']), this.localeSel.localeName, null
    );
  }

  previewContentPlyrLoadTts(e) {
    let filename = '[' + this.templateSel.displayLabel + '][' + this.localeSel.localeName + ']';

    if (this.productSel) {
      filename += '[' + TemplatesService.getOperatorProgramProductDisplayLabel(this.productSel) + ']';
    }

    this.contentPlyrs.find(cPy => cPy.elContentId === e.detail['contentId']).loadTts(
      this.getTemplateContentTextRendered(), this.localeSel.localeName, null, {filename: filename, addSuffixDatetime: true}
    );
  }

  resetPlyr(id: string) {
    const plyr = this.contentPlyrs.find(cPy => cPy.elContentId === id);

    if (plyr) {
      plyr.reset();
    }
  }

  getElementId(name: string, td: TemplateDefinition): string {
    return name + '_' + td.displaySequence;
  }

  getCompContentId(td: TemplateDefinition): string {
    return this.getElementId('compContent', td);
  }

  resetInvalidSsmlTags() {
    this.invalidSsmlTags = [];
  }

  validateSsmlTags() {
    this.resetInvalidSsmlTags();

    const parser = new DOMParser();

    const oDom = parser.parseFromString('<speak version="1.1" ' +
      'xmlns="http://www.w3.org/2001/10/synthesis" ' +
      'xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" ' +
      'xsi:schemaLocation="http://www.w3.org/2001/10/synthesis http://www.w3.org/TR/speech-synthesis11/synthesis.xsd" ' +
      'xml:lang="en-US">' + this.customizingContentEditorText + '</speak>', 'text/xml');

    if (oDom.documentElement.childNodes.length > 0 && oDom.documentElement.childNodes[0].nodeName === 'parsererror') {

      let validText = '';

      for (let i = 1; i < oDom.documentElement.childNodes.length - 1; i++) {
        if (oDom.documentElement.childNodes[i].nodeType === Node.TEXT_NODE) {
          validText += (oDom.documentElement.childNodes[i] as Text).wholeText;
        } else {
          validText += (oDom.documentElement.childNodes[i] as Element).outerHTML;
        }
      }

      const invalidText = this.customizingContentEditorText.substr(validText.length);

      const invalidStart = this.customizingContentEditorText.indexOf(invalidText);
      const invalidEnd = this.customizingContentEditorText.length;

      this.invalidSsmlTags.push({indices: {start: invalidStart, end: invalidEnd}, cssClass: 'bg-pink'});

    }
  }

  sendPreview() {
    const tags: OpeningAndClosingTags = ['{{{', '}}}'];
    this.isRequestingSendPreview = true;
    const delivery_methods = [this.templateDeliveryPathSel.code];
    const template_name = this.templateSel.name;
    const locale_name = this.localeSel.localeName;
    const product_id = this.productSel.id;
    const context_data = TemplatesService.getTemplateContextData(this.getAllTemplateContentTextInPlainFormat(), tags, this.templateComponentVariables);

    const PRODUCT_NAME = this.productSel?.displayLabel ?? 'DEFAULT';
    const PROGRAM_NAME = this.productSel?.program?.displayLabel ?? 'DEFAULT';
    const OPERATOR = this.productSel?.program?.operator?.displayLabel ?? 'DEFAULT';
    const SMS_PROGRAM_LABEL = this.productSel?.program?.shortDisplayLabel ?? 'DEFAULT';
    const timezone_short = this.productSel?.timezone_short;
    const timezone_long = this.productSel?.timezone_long;

    if(PRODUCT_NAME != 'DEFAULT') { context_data['PRODUCT_NAME'] = PRODUCT_NAME; }
    if(PROGRAM_NAME != 'DEFAULT') { context_data['PROGRAM_NAME'] = PROGRAM_NAME; }
    if(OPERATOR != 'DEFAULT') { context_data['OPERATOR'] = OPERATOR; }
    if(SMS_PROGRAM_LABEL != 'DEFAULT') { context_data['SMS_PROGRAM_LABEL'] = SMS_PROGRAM_LABEL; }
    if(timezone_short) { context_data['TIME_ZONE'] = timezone_short; }
    if(timezone_long) { context_data['TIME_ZONE_LONGFORM'] = timezone_long; }

    this.infoPushService.requestPreview(template_name, product_id, locale_name, context_data, delivery_methods).subscribe(
      () => {
        this.isRequestingSendPreview = false;
        this.toastr
          .success(`Your preview request has been registered, you should receive the notification preview in the following minutes.`,
            `Success`);
      },
      (err) => {
        this.isRequestingSendPreview = true;
        throw ErrorDataService.overLoadError(err, 'While requesting preview. ');
      }
    );
  }

  checkVariablesInContent() {
    // It is NOT replacing anything, just matching the regex
    this.customizingContentEditorText.replace(/{{3}(\w+)}{3}/gi,
      (match, capturedGroup, position /*, fullText*/) => {
        if (!this.templateComponentVariables.some(tcv => tcv.displayLabel === capturedGroup)) {
          this.toastr.warning(`The content you are about to save contains "${match}" at position: ${position},` +
            ` which is not a known variable.`);
        }
        return match;
      });
    // It is NOT replacing anything, just matching the regex
    this.customizingContentEditorText.replace(/({+)(\w+)(}+)/gi,
      (match, capturedGroup1, capturedGroup2, capturedGroup3, position /*, fullText*/) => {
        if (capturedGroup1.length !== 3 || capturedGroup3.length !== 3) {
          this.toastr.warning(`The content you are about to save contains "${match}" at position: ${position},` +
            ` which doesn't match the expected variable format. Did you mean "{{{${capturedGroup2}}}}" instead?`);
        }
        return match;
      });
    // It is NOT replacing anything, just matching the regex
    this.customizingContentEditorText.replace(/{{3}([\w]*([^\w]+)[\w]*)}{3}/gi,
      (match, capturedGroup1, capturedGroup2, position /*, fullText*/) => {
        if (!capturedGroup2.match(/[{}]/gi)) {
          this.toastr.warning(`The content you are about to save contains "${match}" at position: ${position}. ` +
            `Some characters within the curly braces are not allowed for a variable name.`);
        }
        return match;
      });
  }

  shouldOpenRightPanel(): boolean {
    return !!this.templateDefinitionSel && !!this.customizingContentEditorText;
  }

  private renderContent(template: string): string {
    const tags: OpeningAndClosingTags = ['{{{', '}}}'];

    const view = TemplatesService.getTemplateContextData(template, tags, this.templateComponentVariables);

    const PRODUCT_NAME = this.productSel?.displayLabel ?? 'DEFAULT';
    const PROGRAM_NAME = this.productSel?.program?.displayLabel ?? 'DEFAULT';
    const OPERATOR = this.productSel?.program?.operator?.displayLabel ?? 'DEFAULT';
    const SMS_PROGRAM_LABEL = this.productSel?.program?.shortDisplayLabel ?? 'DEFAULT';
    const timezone_short = this.productSel?.timezone_short;
    const timezone_long = this.productSel?.timezone_long;

    if(PRODUCT_NAME != 'DEFAULT') { view['PRODUCT_NAME'] = PRODUCT_NAME; }
    if(PROGRAM_NAME != 'DEFAULT') { view['PROGRAM_NAME'] = PROGRAM_NAME; }
    if(OPERATOR != 'DEFAULT') { view['OPERATOR'] = OPERATOR; }
    if(SMS_PROGRAM_LABEL != 'DEFAULT') { view['SMS_PROGRAM_LABEL'] = SMS_PROGRAM_LABEL; }
    if(timezone_short) { view['TIME_ZONE'] = timezone_short; }
    if(timezone_long) {view['TIME_ZONE_LONGFORM'] = timezone_long; }

    return Mustache.render(template.replace(/{{3}/ig, '{{{&'), view, null, tags);
  }

  private getElementBySelector(selector: string): HTMLElement {
    return this.document.querySelector(selector) as HTMLElement;
  }

  private getElementById(id: string): HTMLElement {
    return this.getElementBySelector('#' + id);
  }

  private getElementContentById(id: string): string {
    if (this.templateDefinitionSel) {
      if (this.templateDeliveryPathSel.code === DeliveryPath.EMAIL) {
        return (this.getCompContentElement(id) as HTMLDivElement).innerText;
      } else {
        return (this.getCompContentElement(id) as HTMLTextAreaElement).value;
      }
    }

    return '';
  }

  private getCompContentElement(id: string): Element {
    return this.getElementById(id);
  }

  private isSelectionAContentEditor() {
    let node = this.document.getSelection().anchorNode;

    if (node.nodeName === 'TEXTAREA' || (node as HTMLElement).isContentEditable) {
      return true;
    } else {
      while (node.parentElement !== null) {
        if (node.parentElement.nodeName !== 'TEXTAREA' && !node.parentElement.isContentEditable) {
          node = node.parentNode;
        } else {
          return true;
        }
      }
    }

    return false;
  }

  private getOperatorProgramProductDisplayLabelById(productId: string): string {
    return TemplatesService.getOperatorProgramProductDisplayLabel(this.products.find((p) => p.id === productId));
  }

  private getLocaleName(localeName: string): string {
    return localeName && this.locales && this.locales.some((l) => l.localeName === localeName) ?
      this.locales.find((l) => l.localeName === localeName).displayLabels.en_US :
      'DEFAULT';
  }

  private parseContentText(contentText: string): string {
    return toHTML(
      toDoc(
        contentText,
        templateDefinitionEditorSchema,
      ),
      templateDefinitionEditorSchema
    );
  }

  /**
   * This method is used to remove discrepancy between editor and card views
   */
  private preParse(html: string): string {
    return html
      // Get rid of outer div
      .replace(/^<div[^>]*>(.*)<\/div>$/i, '$1')
      // Remove single trailing hard break in the end
      .replace(/<br\s*\/?>$/i, '')
      // Unwrap divs that contain only hard breaks
      .replace(
        /<div[^>]*>\s*((?:<br\s*\/?>\s*)+)\s*<\/div>/gi,
        (_, breaks) => breaks.replace(/\s+/g, '')
      )
      // Unwrap divs with content and place breaks after them
      .replace(/<div\b[^>]*>([\s\S]*?)<\/div>/gi, '$1<br>');
  }
}
